import { render, staticRenderFns } from "./category_page.vue?vue&type=template&id=a475e1ac&scoped=true"
import script from "./category_page.vue?vue&type=script&lang=js"
export * from "./category_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a475e1ac",
  null
  
)

export default component.exports